import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '@/helpers/user.helper.js'

const API_URL = process.env.VUE_APP_API_URL + 'client/';

class ClientService {

    getClients() {
        return axios.get(API_URL + 'getclientlist', { headers: authHeader() });
    }

    getClient() {
        return axios.get(API_URL + 'getclient/' + UserHelper.getClientId(), { headers: authHeader() });
    }

    createClient(name) {
        return axios.put(API_URL + 'create', {
            name: name
        },
            { headers: authHeader() });
    }

    updateClientName(clientId, newName) {
        return axios.put(API_URL + 'update/' + clientId, {
            name: newName
        },
            { headers: authHeader() });
    }

    changeBaliseClient(clientId, baliseId) {
        return axios.put(API_URL + 'changeBaliseClient', {
            clientId: clientId,
            baliseId: baliseId
        },
            { headers: authHeader() });
    }

    addSms(clientId, amount) {
        return axios.put(API_URL + 'addSms/' + clientId, {
            amount: amount
        },
            { headers: authHeader() });
    }

    updateLockStatus(clientId, lockStatus) {
        return axios.put(API_URL + 'lockClient/' + clientId, {
            locked: lockStatus
        },
            { headers: authHeader() });
    }

    getClientInfo(clientId) {
        return axios.get(API_URL + 'getclient/' + clientId, { headers: authHeader() });
    }
}

export default new ClientService();